<template>
  <Container>
    <div class="h-96 w-full flex justify-center items-center">
      <Heading variant="3" class="text-center">Ничего не найдено</Heading>
    </div>
  </Container>
</template>
